import { mockBuilder } from '../../utils/builderHelper.es.js';
import { ReleaseLyricsLanguage } from './ReleaseLyricsLanguage.es.js';

/** @module Mocks */ /** typedoc */
function aReleaseLyricsLanguage() {
    return mockBuilder(new ReleaseLyricsLanguage()).withName('French').withCode('FR');
}

export { aReleaseLyricsLanguage };
